export default "__VITE_ASSET__CsUHCTi___"